export default __webpack_public_path__ + "static/Quickinstallation_12-f39639a8ee1c0bd4c35c429b73e8c1b4.webp";